// Lightweight slug-only list used by App.tsx for getStaticPaths.
// Keeping this separate from articles.ts prevents the heavy article content
// (with ~60 static image imports) from being pulled into the root bundle.
// Keep in sync with src/data/articles.ts.
export const articleSlugs: string[] = [
  "formia-2026-matteo-gasbarre-allenatore-valerio-venanzi-quinto-dan",
  "accademia-mattei-crescita-giovani-talenti-2026",
  "campionati-italiani-rossano-2026-argento-flavia-marcellini",
  "interregionale-arezzo-2026-prima-gara-stagione",
  "ripartenza-corsi-settembre-2026",
  "programma-off-season-preparazione-estiva-taekwondo",
  "sport-disciplina-bambini-vivaci-iperattivi",
  "organizzare-settimana-scuola-sport-bambini",
  "come-scegliere-sport-bambini-roma",
  "taekwondo-vs-karate-per-bambini",
  "costi-taekwondo-roma",
  "chiusura-stagione-sportiva-2025-2026",
  "gran-prix-roma-kim-e-liu-2026",
  "european-grand-prix-sofia-2026",
  "lazio-combat-2026-fondi",
  "torneo-kim-e-liu-centro-italia-2026-fondi",
  "campionati-interregionali-emilia-romagna-2026-riccione",
  "campionato-italiano-junior-taekwondo-2026",
  "esami-cintura-15-febbraio-2026",
  "accademia-arti-marziali-roma",
  "taekwondo-judo-karate-bambini-roma",
  "taekwondo-portuense-roma",
  "taekwondo-trullo-corviale-roma",
  "taekwondo-bravetta-casetta-mattei",
  "taekwondo-monteverde-casaletto-roma",
  "taekwondo-bambini-6-10-anni-primo-anno",
  "autostima-socializzazione-bambini-taekwondo",
  "esame-cintura-taekwondo-come-funziona",
  "sparring-taekwondo-cos-e-come-funziona",
  "attrezzatura-taekwondo-cosa-serve",
  "taekwondo-adulti-principianti-iniziare",
  "quanto-costa-corso-taekwondo-roma",
  "preparazione-atletica-taekwondo",
  "percorso-agonistico-taekwondo",
  "storia-del-taekwondo-origini-sviluppo-moderno-e-diffusione-nel-mondo",
  "il-taekwondo-in-corea-tradizione-cultura-e-valori-che-restano",
  "wt-e-itf-differenze-tra-le-principali-organizzazioni-del-taekwondo",
  "glossario-taekwondo-60-termini-coreani-che-si-incontrano-in-palestra",
  "poomsae-kyorugi-kyokpa-cosa-significano-e-cosa-si-allena",
  "dobok-dojang-e-dan-termini-che-confondono-i-principianti",
  "cinture-nel-taekwondo-ordine-significato-e-come-funziona-la-progressione",
  "cintura-nera-nel-taekwondo-cosa-significa-davvero-e-cosa-cambia-in-allenamento",
  "esami-di-cintura-criteri-errori-comuni-e-come-prepararsi-senza-ansia",
  "tecniche-di-base-del-taekwondo-calci-pugni-parate-e-posture",
  "i-principali-calci-del-taekwondo-spiegati-bene-esecuzione-errori-e-sicurezza",
  "poomsae-cosa-sono-le-forme-e-come-migliorare-precisione-equilibrio-e-controllo",
  "taekwondo-e-olimpiadi-quando-entra-ai-giochi-e-come-funziona-la-gara",
  "come-si-diventa-atleta-di-taekwondo-percorso-gare-federali-e-sviluppo-a-lungo-termine",
  "regole-e-punteggi-nel-taekwondo-sportivo-guida-semplice-per-chi-guarda-una-gara",
  "sport-individuali-relazioni-sociali-benessere",
  "errore-autostima-non-identificarsi",
  "esami-sociali-cintura-luglio-2026",
];
